import HeroSection, { HeroSectionProps } from "@components/E-Book/Herosection";
import NewLayout from "@components/new-ui/Layout";
import Image from "next/image";
import React from "react";

const HeroSectionData: HeroSectionProps = {
    title: "Unlock More Sales: How E-commerce Brands Win on WhatsApp",
    listHeading: (
        <p>
            Turn casual shoppers into loyal customers by integrating WhatsApp into your e-commerce strategy. <br />
            <br />
            This eBook gives you practical insights to increase conversions, reduce cart abandonment, and boost repeat purchases:
        </p>
    ),
    listText: [
        { label: "70% of carts are abandoned. Learn how WhatsApp can help you recover them with timely nudges and personalized offers." },
        { label: "From order confirmations to shipping updates and post-purchase follow-ups, automate your customer journey." },
        { label: "Create a high-converting storefront on WhatsApp using product catalogs, rich media, and real-time chat." },
    ],
    buttonText: "Download your free Ebook now!",
    mediaUrl: "https://assets.gallabox.com/gb-home/ebook/ecommerce.png",
    altMedia: "gallabox-e-book",
    ebookName: "ecommerce",
};

const EBookWhyWhatsappForBusiness: React.FC = () => {
    return (
        <NewLayout
            title="How E-Commerce Companies Use WhatsApp Automation - Gallabox eBooks"
            description=" The best e-commerce companies in the world use WhatsApp automation tools to create engaging user journeys and bring more revenue. Download the ebook now to learn how"
            canonical="https://gallabox.com/resources/whatsapp-for-ecommerce-ebook"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ebook/ecommerce-og.png" }}
        >
            <HeroSection {...HeroSectionData} />
            <section className="flex flex-col pb-10 pr-12">
                <div className="px-8 max-w-6xl mx-auto client-logos flex flex-col gap-3">
                    <Image width={221} height={56} src="/frame.png" alt={"Frame"} className="flex-shrink" />
                    <div className="lg:flex justify-between items-center">
                        <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-14">Trusted by over 2,000 companies across 40+ countries</h3>
                        <div className="flex justify-center mb-9">
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:block hidden"
                            />
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:hidden"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </NewLayout>
    );
};

export default EBookWhyWhatsappForBusiness;
